export default __webpack_public_path__ + "static/media/generic-error-transparent.1297511b.png";